import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { ChatService } from '@services/chat.service';
import { FriendService } from '@services/friend.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { SearchService } from '@services/search.service';
import { CreateService } from '@services/create.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import * as _ from 'lodash';
@Component({
  selector: 'app-chats',
  templateUrl: './chats.component.html',
  styleUrls: ['./chats.component.sass']
})
export class ChatsComponent implements OnInit {
  show: any = { chat: true, friend: false, wall: false };
  friend: any = { accepted: false, requested: false, received: false };
  friend_accept: any = [];
  wallForm: FormGroup;
  btn_process = false;
  friend_menu = true;
  friend_sent: any = [];
  friend_arr: any = [];
  friend_pending: any = [];
  application = "";
  member_name = "";
  component = "m"
  member_record = 0;
  member_obj: any = [];
  friend_check: any = [];
  dataLoding = false;
  params: any = [];
  response: any = [];
  total_record = 0;
  wall_params: any = [];
  member_view: any = [];
  member_response: any = [];
  member_params: any = [];
  friend_activity: any = [];
  friend_activity_count = 0;
  wall_list: any = [];
  wall_count = 0;
  find_freinds = false;
  member_rows = 20;
  friend_arr_record = 0;
  pageCounter = 1;
  friend_arr_params: any = [];
  user: any = [];
  user_id = "";
  post_error = { description: "" };
  route_params: any = [];
  medias: any = { "photo": "photo", "audio": "music", "video": "video-camera", "blog": "bold" };
  public pconfig: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    dictDefaultMessage: "<i class='fa fa-photo'></i> Photo",
    maxFiles: 1
  };
  constructor(private _createService: CreateService, public ngxSmartModalService: NgxSmartModalService, private _searchService: SearchService, private _friend: FriendService, private _viewService: ViewService, private _chat: ChatService, private fb: FormBuilder, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "chat";
    this.route.queryParams.subscribe(params => {
      this.route_params = params;
      if (this.route_params['show'] == 'friend') {
        this.show[this.route_params['show']] = true;
        this.showFriend();
      } else {
        this.showChat();
      }
    });

    this.wallForm = this.fb.group({
      description: []
    });
    this.user_id = this._global.getSessionVal('id');
    this.user = {
      id: this.user_id,
      name: this._global.getSessionVal('firstName') + "  " + this._global.getSessionVal('lastName')
    };
  }

  ngOnInit(): void {
  }

  loadChatData(p) {
    this.dataLoding = true;
    this._chat.search(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.params = this._global.getVal(data, 'request', '');
          this.response = data["response"]["docs"];
          this.total_record = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  showChat() {
    this.visible('chat');
    let p = {
      "sortOrder": "desc",
      "component": this.component,
      "application": this.application,
    }
    this.loadChatData(p);
  }
  showWall() {
    this.visible('wall');
    let p = {
      application: 'wall',
      component: this.component,
      memberId: this.user_id
    };
    this.loadWallData(p);
  }
  loadWallData(p) {
    this.dataLoding = true;
    this._searchService.wall(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.wall_params = this._global.getVal(data, 'request', '');
          this.wall_list = data["response"]["docs"];
          this.wall_count = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  showFriend() {
    this.visible('friend');
    this.btn_process = false;
    this.friend = { accepted: false, requested: false, received: false };
    this.friend_menu = true;
    this.find_freinds = false;
    this.dataLoding = true;
    let p = {
      application: 'member',
      component: this.component,
      id: this._global.getSessionVal('id')
    };
    this._viewService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.member_view = this._global.getVal(data, 'response', '');
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    let pa = {
      application: 'activities',
      component: this.component
    };
    this._friend.activities(pa).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.friend_activity = data["response"]["docs"];
          this.friend_activity_count = this._global.getVal(data, 'response.numFound', '0');
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

  visibleFriendARR(template) {
    Object.entries(this.friend).forEach(([key, value]) => {
      if (template == key) {
        this.friend[key] = true;
      } else {
        this.friend[key] = false;
      }
    });
  }
  goBack(){
    this.showFriend();
  }
  visible(template) {
    Object.entries(this.show).forEach(([key, value]) => {
      if (template == key) {
        this.show[key] = true;
      } else {
        this.show[key] = false;
      }
    });
  }
  searchMember() {
    this.visible('friend');
    this.friend_menu = false;
    this.find_freinds = true;
    this.member_name = "";
    let p = {
      application: 'member',
      component: this.component,
      start: 0,
      rows: this.member_rows
    };
    this.loadMembers(p);
  }
  loadMembers(p) {
    this.dataLoding = true;
    this._searchService.application(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.member_params = this._global.getVal(data, 'request', '');
          this.member_response = data["response"]["docs"];
          this.member_record = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  getMembers(e) {
    // this.member_response=[];
    let p = {
      component: this.component,
      application: 'member',
      start: 0,
      firstName: this.member_name,
      lastName: this.member_name,
      sortOrder: 'desc',
      sortString: 'createdTime',
      rows: this.member_rows
    };
    this.loadMembers(p);

  }
  onScrollDown() {

    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.member_record <= this.pageCounter * this.member_rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.member_params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.member_rows;
        p['component'] = this.component;
        this._searchService.application(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.member_response = this.member_response.concat(data["response"]["docs"]);
              this.dataLoding = false;
              this.pageCounter += 1;
              this.member_params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    }
  }
  showProfile(obj) {
    let m = {
      id: obj.id,
      firstName: obj.firstName,
      lastName: obj.lastName,
      email: obj.email,
      gender: obj.gender
    };

    this.member_obj = m;
    let p = {
      component: 'm',
      application: 'member',
      friendId: obj.id
    };
    this._friend.friendCheck(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.friend_check = this._global.getVal(data, 'response', '');
          this.ngxSmartModalService.getModal('dfriendprofile').open();
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  memberFriend(action) {
    console.log(action);
    this.visibleFriendARR(action);
    //this.friend[action]=true;
    this.friend_menu = false;
    console.log(this.friend);
    let p = {
      component: this.component,
      application: 'member',
      start: 0,
      sortOrder: 'desc',
      sortString: 'createdTime',
      rows: this.member_rows
    };
    this.loadFriendMembers(p, action)
  }

  loadFriendMembers(p, action) {
    this.friend_arr = [];
    this.dataLoding = true;
    this.friend_arr_record = 0;
    this._friend.search(p, action).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.friend_arr = data["response"]["docs"];
          this.friend_arr_record = this._global.getVal(data, 'response.numFound', '0');
          this.friend_arr_params = this._global.getVal(data, 'request', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onFriendAcceptScrollDown() {
    // alert("accept");
  }
  onFriendSentScrollDown() {
    // alert("sent");
  }
  onFriendPendingScrollDown() {
    //  alert("pending");
  }
  action(member, action) {
    this.btn_process = true;
    let p = {
      application: 'member',
      component: this.component,
      friendId: member['id']
    };
    this._friend.action(p, action).subscribe(
      data => {
        //  this.showFriend();
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let res = this._global.getVal(data, 'response', {});
          this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
          let p = {
            application: 'chat',
            comment: 'hii',
            component: this.component,
            friendId: this._global.getVal(res, 'id', ''),
          };
          this._chat.create(p).subscribe(
            data => {
              if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {

              }

            },
            error => {
              console.log("error", JSON.stringify(error));
            });


        } else {
          this._global.showMessage({ "type": 'warning', "message": this._global.getVal(data, 'message.error', '') });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  gotoChat(obj) {
    this.btn_process = true;
    let numFound = 0;
    let p = {
      comment: this.component,
      application: this.application,
      id: obj['id']
    }
    this._chat.search(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.response = data["response"]["docs"];
          numFound = this._global.getVal(data, 'response.numFound', 0);
          if (numFound == 0) {
            let p = {
              application: 'chat',
              component: this.component,
              friendId: obj['id'],
              comment: 'Welcome'
            };
            this._chat.create(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
                  let res = this._global.getVal(data, 'response', {});
                  let id = this._global.getVal(res, 'friendId', '');
                  let chatId = this._global.getVal(res, 'id', '');
                  this.chatPage({ id: id, chatId: chatId });

                }

              },
              error => {
                console.log("error", JSON.stringify(error));
              });
          } else {
            this.chatPage({ id: obj['id'], chatId: this._global.getVal(this.response[0], 'chatId', '') });
          }
        }else{
          this.response = data["response"]["docs"];
          numFound = this._global.getVal(data, 'response.numFound', 0);
          if (numFound == 0) {
            let p = {
              application: 'chat',
              component: this.component,
              friendId: obj['id'],
              comment: 'Welcome'
            };
            this._chat.create(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
                  let res = this._global.getVal(data, 'response', {});
                  let id = this._global.getVal(res, 'friendId', '');
                  let chatId = this._global.getVal(res, 'id', '');
                  this.chatPage({ id: id, chatId: chatId });

                }

              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  chatPage(m) {
    this.router.navigate(['/chat'], { queryParams: { 'id': m['id'], 'cid': m['chatId'] } });
  }
  post() {
    this.post_error = { description: "" };
    this.btn_process = true;
    let p = this.wallForm.value;
    p = this._global.paramsRemoveNull(p);
    p['mediaId'] = this.user_id
    p['application'] = 'comment';
    p['component'] = this.component;
    p['mediaType'] = 'member';
    this._createService.comment(p).subscribe(
      data => {
        if (data["status"] == "1") {
          let res = this._global.getVal(data, 'response', {});
          let p = {
            comment: this.component,
            application: 'wall',
            memberId: this.user_id,
            entityType: 'comment',
            entityId: this._global.getVal(res, 'id', '')
          };
          this._createService.wallPost(p).subscribe(
            data => {
              if (data["status"] == "1") {
                this.btn_process = false;
                this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
                let m = {
                  description: this._global.getVal(res, 'description', '')
                };
                data["response"]['entityObject'] = m;
                let r = this.wall_list;
                this.wall_list = [];
                this.wall_list.push(data["response"]);
                this.wall_list = this.wall_list.concat(r);
              }
            },
            error => {
              console.log("error", JSON.stringify(error));
            });

          this.wallForm.reset();
        } else {
          for (let key in data["errors"]) {
            this.post_error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  friendActivities() {
    this.router.navigate(['/friend/activities']);
  }
  friendMedia(media) {
    this.router.navigate(['/friend/' + media], { queryParams: { 'createdBy': this.user_id } });
  }
  getChatEntity(obj) {
    let entity = '';
   
    let path =this._global.getVal(obj,'pathToMedia',{});
    Object.entries(path).forEach(([key, value]) => {
      if (value) {
        entity = this._global.getVal(value, 'entityType', '');
      }
    });
    return entity
  }
  gotoProfile(obj) {
    let id = this._global.getVal(obj, 'id', '');
    if (this._global.isOwner(id)) {
      this.router.navigate(['/my']);
    } else {
      this.router.navigate(['/view/member'], { queryParams: { 'id': id } });
    }
  }
  /*  public onUploadInit(args: any): void {
    // args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, '');
   }
   public onUploadError(args: any): void {
   }
 
   public onUploadSuccess(args: any): void {
     let res = JSON.parse(args[1]);
     if (this._global.getVal(res, 'id', '')) {
     //  this.app_create = false;
       //this.response['name'] = this._global.getVal(res, 'name', '');
      // this.response['id'] = this._global.getVal(res, 'uid', '');
     }
   } */
}
